{
  "version": 1,
  "asset_id": "2b0975d8-7e60-432c-9f22-91ff521a4482",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/2b0975d8-7e60-432c-9f22-91ff521a4482/stamped-concrete-patio-finished-1.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/2b0975d8-7e60-432c-9f22-91ff521a4482/stamped-concrete-patio-finished-1.webp",
  "original_filename": "stamped-concrete-patio-finished-1.webp",
  "size": 312300,
  "content_type": "image/webp",
  "created_at": "2026-09-11T22:26:17Z"
}
